import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './modules/shared/security/services/auth-guard.service';
const routes: Routes = 
[
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    canActivate: [AuthGuard],
    loadComponent: () => import('./modules/login/login.component').then(m => m.LoginComponent),
  },
  {
    path: 'home',
    canActivate: [AuthGuard],
    data: {code: 'home'},
    loadComponent: () => import('./modules/home/home.component').then(m => m.HomeComponent),
  },
  {
    path: 'clients',
    canActivate: [AuthGuard],
    data: {code: 'clients'},
    loadComponent: () => import('./modules/clients/clients.component').then(m => m.ClientsComponent),
  },
  {
    path: 'clientsEdit',
    canActivate: [AuthGuard],
    data: {code: 'clientsEdit'},
    loadComponent: () => import('./modules/clientsEdit/clientsEdit.component').then(m => m.ClientsEditComponent),
  },
  {
    path: 'delegations',
    canActivate: [AuthGuard],
    data: {code: 'delegations'},
    loadComponent: () => import('./modules/delegations/delegations.component').then(m => m.DelegationsComponent),
  },
  {
    path: 'delegationsEdit',
    canActivate: [AuthGuard],
    data: {code: 'delegationsEdit'},
    loadComponent: () => import('./modules/delegationsEdit/delegationsEdit.component').then(m => m.DelegationsEditComponent),
  },
  {
    path: 'certificatesAudit',
    canActivate: [AuthGuard],
    data: {code: 'certificatesAudit'},
    loadComponent: () => import('./modules/certificatesAudit/certificatesAudit.component').then(m => m.CertificatesAuditComponent),
  },
  {
    path: 'certificatesAuditDetailGlobal',
    canActivate: [AuthGuard],
    data: {code: 'certificatesAuditDetailGlobal'},
    loadComponent: () => import('./modules/certificatesAuditDetailGlobal/certificatesAuditDetailGlobal.component').then(m => m.CertificatesAuditDetailGlobalComponent),
  },
  {
    path: 'certificates',
    canActivate: [AuthGuard],
    data: {code: 'certificates'},
    loadComponent: () => import('./modules/certificates/certificates.component').then(m => m.CertificatesComponent),
  },
  {
    path: 'certificatesEdit',
    canActivate: [AuthGuard],
    data: {code: 'certificatesEdit'},
    loadComponent: () => import('./modules/certificatesEdit/certificatesEdit.component').then(m => m.CertificatesEditComponent),
  },
  {
    path: 'certificatesDesign',
    canActivate: [AuthGuard],
    data: {code: 'certificatesDesign'},
    loadComponent: () => import('./modules/certificatesDesigner/certificatesDesigner.component').then(m => m.CertificatesDesignerComponent),
  },
  {
    path: 'certificatesDesignerEdit',
    canActivate: [AuthGuard],
    data: {code: 'certificatesDesignerEdit'},
    loadComponent: () => import('./modules/certificatesDesignerEdit/certificatesDesignerEdit.component').then(m => m.CertificatesDesignerEditComponent),
  },
  {
    path: 'certificatesVersionHistoric',
    canActivate: [AuthGuard],
    data: {code: 'certificatesVersionHistoric'},
    loadComponent: () => import('./modules/certificatesVersionHistoric/certificatesVersionHistoric.component').then(m => m.CertificatesVersionHistoricComponent),
  },
  {
    path: 'certificatesVersionEdit',
    canActivate: [AuthGuard],
    data: {code: 'certificatesVersionEdit'},
    loadComponent: () => import('./modules/certificatesVersionEdit/certificatesVersionEdit.component').then(m => m.CertificatesVersionEditComponent),
  },
  {
    path: 'dataSources',
    canActivate: [AuthGuard],
    data: {code: 'dataSources'},
    loadComponent: () => import('./modules/dataSources/dataSources.component').then(m => m.DataSourcesComponent),
  },
  {
    path: 'dataSourcesEdit',
    canActivate: [AuthGuard],
    data: {code: 'dataSourcesEdit'},
    loadComponent: () => import('./modules/dataSourcesEdit/dataSourcesEdit.component').then(m => m.DataSourcesEditComponent),
  },
  {
    path: 'logs',
    loadComponent: () => import('./modules/logs/logs.component').then(m => m.LogsComponent),
  },
  {
    path: 'queries',
    canActivate: [AuthGuard],
    data: {code: 'queries'},
    loadComponent: () => import('./modules/queries/queries.component').then(m => m.QueriesComponent),
  },
  {
    path: 'queriesEdit',
    canActivate: [AuthGuard],
    data: {code: 'queriesEdit'},
    loadComponent: () => import('./modules/queriesEdit/queriesEdit.component').then(m => m.QueriesEditComponent),
  },
  {
    path: 'templates',
    canActivate: [AuthGuard],
    data: {code: 'templates'},
    loadComponent: () => import('./modules/templates/templates.component').then(m => m.TemplatesComponent),
  },
  {
    path: 'templatesEdit',
    canActivate: [AuthGuard],
    data: {code: 'templatesEdit'},
    loadComponent: () => import('./modules/templatesEdit/templatesEdit.component').then(m => m.TemplatesEditComponent),
  },
  {
    path: 'userManagement',
    canActivate: [AuthGuard],
    data: {code: 'userManagement'},
    loadComponent: () => import('./modules/userManagement/userManagement.component').then(m => m.UserManagementComponent),
  },
  {
    path: 'userManagementEdit',
    canActivate: [AuthGuard],
    data: {code: 'userManagementEdit'},
    loadComponent: () => import('./modules/userManagementEdit/userManagementEdit.component').then(m => m.UserManagementEditComponent),
  },
  {
    path: 'userProfile',
    canActivate: [AuthGuard],
    data: {code: 'userProfile'},
    loadComponent: () => import('./modules/userProfile/userProfile.component').then(m => m.UserProfileComponent),
  },
  {
    path: 'collections',
    canActivate: [AuthGuard],
    data: {code: 'collections'},
    loadComponent: () => import('./modules/collections/collections.component').then(m => m.CollectionsComponent),
  },
  {
    path: 'countries',
    canActivate: [AuthGuard],
    data: {code: 'countries'},
    loadComponent: () => import('./modules/countries/countries.component').then(m => m.CountriesComponent),
  },
  {
    path: 'countriesEdit',
    canActivate: [AuthGuard],
    data: {code: 'countriesEdit'},
    loadComponent: () => import('./modules/countriesEdit/countriesEdit.component').then(m => m.CountriesEditComponent),
  }
];

@NgModule({ imports: [RouterModule.forRoot(routes)], exports: [RouterModule] })
export class AppRoutingModule { }